import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { unmuteRemotePhoneUserRequested } from 'features/sip/actions';
import { logger } from 'utils/logger';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';

export function* unmuteRemotePhoneAudioSaga(
  action: ReturnType<typeof unmuteRemotePhoneUserRequested>
) {
  logger
    .remote({ action: true, tier: 1 })
    .log(`Unmute phone audio remotely for the user id=${action.payload.id}`);

  yield call(SignalingSocket.send, {
    event: 'askToUnmutePhoneUser',
    data: {
      id: action.payload.id,
    },
  });

  yield call(notification, i18n.t('notifications:unmute_request_sent'));
}
